export interface ISizePrice {
  readonly id?: number;
  readonly guid?: string;
  readonly number?: number;
  readonly name: string;
  readonly price: number;
  readonly sku?: string;        // Size-specific SKU (e.g., "COKE-SM", "COKE-MD", "COKE-LG")
  readonly upc?: string;        // Size-specific UPC/barcode (industry standard for beverages)
  readonly barcode?: string;    // Alternative barcode format
}

export interface ISizePriceData {
  id?: number;
  guid?: string;
  number?: number;
  name: string;
  price?: number;
  sku?: string;
  upc?: string;
  barcode?: string;
}

export class SizePrice implements ISizePrice {
  readonly id?: number;
  readonly guid?: string;
  readonly number?: number;
  readonly name: string;
  readonly price: number;
  readonly sku?: string;
  readonly upc?: string;
  readonly barcode?: string;

  constructor(data: ISizePriceData) {
    this.id = data.id;
    this.guid = data.guid;
    this.number = data.number;
    this.name = data.name;
    this.price = data.price ?? 0;
    this.sku = data.sku;
    this.upc = data.upc;
    this.barcode = data.barcode;
  }

  toJSON(): ISizePrice {
    return {
      id: this.id,
      guid: this.guid,
      number: this.number,
      name: this.name,
      price: this.price,
      sku: this.sku,
      upc: this.upc,
      barcode: this.barcode,
    };
  }

  static fromJSON(data: Record<string, unknown>): SizePrice {
    if (!data.name) throw new Error("SizePrice.fromJSON: name is missing.");

    return new SizePrice({
      id: data.id as number | undefined,
      guid: data.guid as string | undefined,
      number: data.number as number | undefined,
      name: data.name as string,
      price: data.price as number | undefined,
      sku: data.sku as string | undefined,
      upc: data.upc as string | undefined,
      barcode: data.barcode as string | undefined,
    });
  }
} 